function o(e, t) {
  return typeof t == "string" ? t.split(".").reduce((r, n) => r[n], e) : e[t];
}
export {
  o as l
};
